import {
	BaseServiceSetup,
	context,
	defineExperiment,
	Experiment,
	getExperiment,
	isExperimentEnabled,
	utils,
} from '@wikia/ad-engine';

type RunningExperiment = Experiment | null | undefined;

export class UcpMobileFeaturedVideoExperiment extends BaseServiceSetup {
	private name = 'ucpMobileFeaturedVideoExperiment';

	private variants = {
		variant1: 'cotech-1885-variant1',
	};

	private controls = {
		control1: 'cotech-1885-control1',
		control2: 'cotech-1885-control2',
	};

	private excludedCountries: string[] = [
		'US',
		'MX',
		'AU',
		'DE',
		'GB',
		'IT',
		'CA',
		'FR',
		'SE',
		'CL',
		'AR',
	];

	private activeVariant: RunningExperiment = getExperiment([
		defineExperiment({
			name: this.variants.variant1,
			buckets: ['51', '52', '53', '54', '55', '56', '57', '58', '59', '60'],
		}),
		defineExperiment({
			name: this.controls.control1,
			buckets: ['9', '10', '11', '12', '13', '14', '15', '16', '17', '18'],
		}),
		defineExperiment({
			name: this.controls.control2,
			buckets: ['19', '20', '21', '22', '61', '62', '63', '64', '65', '66'],
		}),
	]);

	call(): void {
		if (this.isExperimentDisabled() || this.isCountryIneligible()) {
			this.log('Experiment disabled');
			context.set('experiments.disableFeaturedVideo', false);
			return;
		}

		this.log('Experiment enabled');

		const activeControl = this.activeControlName();
		const isControl = Boolean(activeControl);

		this.log(isControl ? 'Control triggered' : 'Variant triggered');

		context.set('experiments.disableFeaturedVideo', !isControl);
	}

	private activeControlName(): string | undefined {
		const controlNames = Object.values(this.controls);
		const activeVariantName = this.activeVariant?.name;
		return activeVariantName && controlNames.includes(activeVariantName)
			? activeVariantName
			: undefined;
	}

	/**
	 * Returns true if the user's country is in the excluded list (i.e., ineligible for the experiment)
	 */
	private isCountryIneligible(): boolean {
		return utils.isProperCountry(this.excludedCountries);
	}

	private isExperimentDisabled(): boolean {
		return !isExperimentEnabled(this.instantConfig, this.name, this.activeVariant);
	}

	private log(message: string) {
		utils.logger(this.name, message);
	}
}
